<template>
  <div class="view-container">
    <mobialis-form-with-validation
      @onValidate="submit"
      novalidate
      v-slot="{ errors }"
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <div class="inner-content">
        <h2 class="mt-sm-5 text-center mb-5">{{ $t('message.trade.selectVehicleType.heading') }}</h2>
        <div class="row form-row mb-3">
          <div class="col-sm-6" v-for="(option, index) in radioButtonOptions" :key="index">
            <MobialisFancyRadio
              vid="vehicleCategoryType"
              rules="required"
              :textArray="[option]"
              name="radioButtonOptions"
              v-model="vehicleCategoryType"
              :data-cy="option.value"
            ></MobialisFancyRadio>
          </div>
          <div class="col">
            <p
              class="text-danger small my-0"
              v-if="errors.vehicleCategoryType && errors.vehicleCategoryType.length > 0 && !vehicleCategoryType"
            >
              {{ $t('message.common.pleaseSelect') }}
            </p>
          </div>
        </div>
        <div v-if="vehicleCategoryType === VehicleCategoryTypes.AUTO">
          <!--           @TODO trade-auto-complete when VRM removed will always use YearMakeModelSelector-->
          <year-make-model-selector v-if="tradeInSourceIsCarfax" data-cy="ymmSelector" />
          <trade-auto-complete
            v-else
            v-model="vehicleSelected"
            :valueObject="selectedVehicleObject"
            :label="$t('message.trade.autoFillLabel')"
            :placeholder="$t('message.trade.autoFillPlaceHolder')"
            :hidden-label="true"
            @selectedVehicleObject="selectedTradeVehicle"
          >
          </trade-auto-complete>
        </div>
      </div>
      <div class="submit-button-container my-4 pt-5">
        <mobialis-button type="submit" data-cy="submit">{{ $t('message.common.continue') }}</mobialis-button>
      </div>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapGetters } from 'vuex';
import TradeAutoComplete from '@/components/shared/TradeAutoComplete.vue';
import { VehicleCategoryTypes } from '@/utils/enums';
import YearMakeModelSelector from '@/components/shared/trade-in-carfax/YearMakeModelSelector.vue';
import TradeInSource from '@/utils/enums/tradeInSource';

export default {
  name: 'SelectTradeVehicleType',
  components: { YearMakeModelSelector, TradeAutoComplete },
  data() {
    return {
      VehicleCategoryTypes,
      vehicleSelected: '',
      selectedVehicleObject: {},
      vehicleCategoryType: cloneDeep(this.$store.state.trade.vehicle.vehicleCategoryType),
      radioButtonOptions: [
        {
          label: this.$t('message.trade.selectVehicleType.automotive'),
          value: VehicleCategoryTypes.AUTO,
        },
        {
          label: this.$t('message.trade.selectVehicleType.recreational'),
          value: VehicleCategoryTypes.RECREATIONAL,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getVehicleName: 'trade/getVehicleName',
      getBaseVehicleObject: 'trade/getBaseVehicleObject',
    }),
    tradeInSourceIsCarfax() {
      return this.$store.getters['business/getTradeInSource'] === TradeInSource.CARFAX;
    },
  },
  mounted() {
    if (this.vehicleCategoryType === VehicleCategoryTypes.AUTO) {
      this.vehicleSelected = this.getVehicleName;
      this.selectedVehicleObject = this.getBaseVehicleObject;
    }
  },
  methods: {
    selectedTradeVehicle(vehicle) {
      this.selectedVehicleObject = vehicle;
    },
    submit(isValid) {
      if (!isValid) {
        return;
      }
      if (this.vehicleCategoryType === VehicleCategoryTypes.RECREATIONAL) {
        this.$store.commit('trade/RESET_VEHICLE');
        this.$store.commit('trade/SET_TRADE_VEHICLE_CATEGORY_TYPE', this.vehicleCategoryType);
        this.$router.push({
          name: `trade-vehicle-details-${this.baseRoute}`,
        });
      } else if (this.vehicleCategoryType === VehicleCategoryTypes.AUTO) {
        // @TODO remove/clean code that support VMR when VRM removed should always redirect to carfax-details-form
        this.$store.commit('trade/SET_TRADE_VEHICLE_CATEGORY_TYPE', this.vehicleCategoryType);
        let params = {};
        if (this.tradeInSourceIsCarfax) {
          this.$store.commit('trade/SET_LEAD_TRADEIN_VEHICLE');
          params = {
            year: this.$store.state.trade.vehicle.year,
            make: this.$store.state.trade.vehicle.make,
            model: this.$store.state.trade.vehicle.model,
          };
          this.$router.push({ path: `${params.year}/${params.make}/${params.model}/carfax-details-form` });
        } else {
          this.$store.commit('trade/SET_VEHICLE', this.selectedVehicleObject);
          params = {
            year: encodeURIComponent(this.selectedVehicleObject.year),
            make: encodeURIComponent(this.selectedVehicleObject.make),
            model: encodeURIComponent(this.selectedVehicleObject.model),
            trim: encodeURIComponent(this.selectedVehicleObject.trim) || 'no-trim',
            style: encodeURIComponent(this.selectedVehicleObject.style),
          };
          const location = {
            name: `personal-info-form-${this.baseRoute}`,
            params,
          };
          this.$router.push(location);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.inner-content {
  max-width: 590px;
  margin: 0 auto;
}
@media only screen and (min-width: $breakpoint-mobile) {
  .view-container {
    min-height: calc(100vh - 280px);
    padding-bottom: 112px;
    position: relative;
    margin-bottom: 40px;
    .submit-button-container {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
